<template>
<v-app class="ma-0 pa-0" id="app">
     <v-layout class="upper-row" row wrap>
      <v-flex xs2 sm2>
      </v-flex>
      <v-flex xs8 sm8>
     <v-card
    class="mx-auto"
    outlined
  >
   <v-form class="pa-8">
                 <v-text-field
                        v-model="formInput.firstname"
                        label="Vorname"
                        name="Vorname"
                         :error-messages="firstnameErrors"
                        prepend-icon="mdi-account"
                        type="text"
                      ></v-text-field>

                      <v-text-field
                        v-model="formInput.lastname"
                        label="Nachname"
                        name="Nachname"
                         :error-messages="lastnameErrors"
                        prepend-icon="mdi-account"
                        type="text"
                      ></v-text-field>

                      <v-select
                        :items="items"
                        v-model="formInput.gender"
                         :error-messages="genderErrors"
                         prepend-icon="mdi-gender"
                        label="Geschlecht"
                        ></v-select>


                      <v-text-field
                        v-model="formInput.email"
                        label="Email"
                        name="Email"
                         :error-messages="emailErrors"
                        prepend-icon="mdi-email"
                        type="email"
                      ></v-text-field>
                  <span v-if="emailexisted">Die angegebene Email ist uns bereits bekannt.</span>
                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    v-model="formInput.password"
                    :error-messages="passErrors"
                    prepend-icon="mdi-lock-open"
                    type="password"
                  ></v-text-field>

                  
                  <v-text-field
                    id="confirmPassword"
                    label="Password bestätigen"
                    name="Password bestätigen"
                    v-model="formInput.repassword"
                   :error-messages="passErrors"
                    prepend-icon="mdi-lock"
                    type="password"
                  ></v-text-field>

                </v-form>
                <md-card-actions>
        <v-btn @click="validateUser()" v-if="!loggedIn" class="md-raised md-primary CTA CTA--Main">
            <span class="buttonText">Jetzt Registrieren</span>
          </v-btn>
      </md-card-actions>
      <v-progress-linear v-if="sending"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
     </v-card>
     </v-flex>
      <v-flex xs2 sm2>
      </v-flex>
     </v-layout>
</v-app>
                
</template>
<script>
import auth from "../auth";
import { validationMixin } from 'vuelidate'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'

export default {
  name: "Signup",
  validations: {
    formInput: {
      firstname: {
        required,
        minLength: minLength(3)
      },
      lastname: {
        required,
        minLength: minLength(3)
      },
      gender: {
        required
      },
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      },
      repassword: {
        required,
        sameAsPassword: sameAs("password")
      }
    }
  },
  data() {
    return {
      error: false,
      emailexisted: false,
      items:["m","f","d"],
      formInput: {
        firstname: '',
        lastname: '',
        gender: '',
        email: '',
        password: '',
        letter: false
      },
      loggedIn: false,
      sending: false
    };
  }, 
  computed: {
      firstnameErrors () {
        const errors = []
        if (!this.$v.formInput.firstname.$dirty) return errors
        !this.$v.formInput.firstname.required && errors.push('Vorname ist ein Pflichfeld')
        return errors
      },
      lastnameErrors () {
        const errors = []
        if (!this.$v.formInput.lastname.$dirty) return errors
        !this.$v.formInput.lastname.required && errors.push('Nachame ist ein Pflichfeld')
        return errors
      },
      emailErrors () {
        const errors = []
        if (!this.$v.formInput.email.$dirty) return errors
        !this.$v.formInput.email.email && errors.push('Keine gültige Email-Adresse')
        !this.$v.formInput.email.required && errors.push('Email ist ein Pflichfeld')
        return errors
      },
      passErrors () {
        const errors = []
        if (!this.$v.formInput.password.$dirty) return errors
        !this.$v.formInput.password.required && errors.push('Passwort ist ein Pflichfeld, bitte verwenden Sie mindestens 8 Zeichen')
        return errors
      },
      repassErrors () {
        const errors = []
        if (!this.$v.formInput.repassword.$dirty) return errors
        !this.$v.formInput.repassword.sameAsPassword && errors.push('Die beiden Passwörter stimmen nicht überein')
        return errors
      },
      genderErrors(){
        const errors = []
        if (!this.$v.formInput.gender.$dirty) return errors
        !this.$v.formInput.gender.required && errors.push('Geschlecht ist ein Pflichfeld')
        return errors
      }
      },
  methods: {
    clearformInput() {
      this.$v.$reset();
      this.formInput.gender = null;
      this.formInput.firstname = null;
      this.formInput.lastname = null;
      this.formInput.email = null;
      this.formInput.password = null;
      this.formInput.repassword = null;
    },
    clearMail() {
      this.formInput.email = null;
    },
    register() {
      this.sending = true;
      console.log(this.formInput)
      auth
        .register(
          this.formInput.email,
          this.formInput.password,
          this.formInput.firstname,
          this.formInput.lastname,
          this.formInput.gender,
          this.formInput.letter
        )
        .then(res => {
          if (!res.data.userExisted) {
            this.sending = false;
            this.$router.push({ name: "signupsuccess" });
          } else {
            this.clearMail();
            this.error = true;
            this.emailexisted = true;
            this.sending = false;
            window.setTimeout(() => {
              this.error = false;
              this.emailexisted =false;
            }, 3000);
          }
        })
    },
    validateUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.register();
      }
    }
  }
};

</script>